import { inject } from 'vue'
import type { App as Application } from 'vue'
import mitt from 'mitt'
import type { Emitter } from 'mitt'
import type { SbRecordType } from '@/composables/useCommandBar/types'
import type { AssetFolder } from '@/types/assetFolders'
import type { Folder } from '@/utils/specifics/folders'

type Events = {
  'saving-story': (storyId: number) => void
  'publishing-story': (storyId: number) => void
  'set-commandbar-record': (recordType: SbRecordType) => void
  'save-stacked-story': unknown
  'saved-stacked-story': () => void
  'toggle-all': boolean
  'field-focus': { schema: Record<string, unknown>; id: string }
  'headline-field-focused': void
  'toggle-block-content': string
  'toggle-children':
    | { folder: AssetFolder; isOnMoveModal: boolean }
    | { folder: Folder; isModal: boolean }
  'rt-drag-start': unknown
  'rt-drag-end': unknown
}

export const EmitterInjectionKey = Symbol()

export default {
  install: function (app: Application): void {
    const emitter = mitt()
    app.config.globalProperties.$emitter = emitter
    app.provide(EmitterInjectionKey, emitter)
  },
}

export function useEmitter(): Emitter<Events> | undefined {
  return inject(EmitterInjectionKey)
}
